





















































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import RangeForm from './rangeForm.vue'
import MultipleInput from '@/utils/MultipleInputs'
import { hasValue } from '@/utils/util'
import WeiJueRules from './components/WeiJueRules.vue'
import FuKanRules from './components/FuKanRules.vue'
import GeneralConfigure from './components/GeneralConfigure.vue'
import { CAR_INSURANCE } from '@/utils/const'
const ALL_INSURANCE = '-1'
const MAX_PENDING = 20
const MAX_RESURVEY = 20

@Component({
	components: {
		RangeForm,
		WeiJueRules,
		FuKanRules,
		GeneralConfigure,
	},
})
export default class RuleForm extends Vue {
	private ruleForm: any = {}
	private ruleContentForm: any = {}
	private ruleTypeList: any[] = []
	private WEI_JUE = '11'
	private FU_KAN = '22'
	private ruleTaskTypeList = [
		{
			label: '未决回访',
			value: this.WEI_JUE,
		},
		{
			label: '住院复勘',
			value: this.FU_KAN,
		},
	]
	private RULE_WHOLEPROCESS = '2'
	private RULE_GENERAL = '3'
	private pendingMulti: any = {}
	private resurveyMulti: any = {}

	@Prop({})
	private data!: any

	private get insuranceTypeList() {
		return [{ key: ALL_INSURANCE, value: '全部' }].concat(
			this.$store.state.setting.insuranceTypeList
		)
	}

	@Watch('data', { immediate: true })
	private onDataChange() {
		if (!this.data) {
			return
		}

		const data = this.data
		this.$nextTick(() => {
			const ruleTaskType: string[] = []
			if ('trackRule' in data) {
				ruleTaskType.push(this.WEI_JUE)
			}
			if ('reviewRule' in data) {
				ruleTaskType.push(this.FU_KAN)
			}

			this.setRuleTypeList(data.insuranceType)
			this.ruleForm.setFieldsValue({
				ruleName: data.ruleName,
				ruleDesc: data.ruleDesc,
				insuranceType: data.insuranceType,
				ruleBaseType: data.ruleBaseType,
				status: data.status === '1',
			})
			this.$nextTick(() => {
				if ([this.RULE_WHOLEPROCESS].includes(data.ruleBaseType)) {
					this.ruleContentForm.setFieldsValue({
						ruleTaskType,
						factory: {
							icu: data.factory && data.factory.icu,
							taskGenerateTime: data.factory && data.factory.taskGenerateTime,
						},
					})
				}
			})
		})
	}

	private setRuleTypeList(insuranceType: string) {
		const ruleBaseTypeList = this.$store.state.setting.ruleBaseTypeList
		if ([CAR_INSURANCE].includes(insuranceType)) {
			this.ruleTypeList = ruleBaseTypeList
		} else if ([ALL_INSURANCE].includes(insuranceType)) {
			this.ruleTypeList = ruleBaseTypeList.filter(
				(item: any) => item.key === this.RULE_GENERAL
			)
		} else {
			this.ruleTypeList = []
		}
	}

	private onInsuranceChange(insuranceType: string) {
		this.ruleForm.resetFields('ruleBaseType')
		this.ruleContentForm.resetFields()
		this.setRuleTypeList(insuranceType)
	}

	private onRuleTypeChange(ruleBaseType: string) {
		this.ruleContentForm.resetFields()
	}

	private addPendingSec() {
		this.pendingMulti.add()
	}

	private removePendingSec(index: number) {
		this.pendingMulti.remove(index)
	}

	private addResurveySec() {
		this.resurveyMulti.add()
	}

	private removeResurveySec(index: number) {
		this.resurveyMulti.remove(index)
	}

	private getForm() {
		return new Promise(async (resolve, reject) => {
			this.ruleForm.validateFields(async (errors: any, values1: any) => {
				if (!errors) {
					values1.status = values1.status ? '1' : '0'

					if (values1.ruleBaseType === this.RULE_WHOLEPROCESS) {
						this.ruleContentForm.validateFields(
							async (err: any, values2: any) => {
								if (!errors) {
									let values = Object.assign(values1, values2)
									if (values.ruleTaskType.includes(this.WEI_JUE)) {
										const weiJueForm = await (this.$refs
											.weiJueRules as any).getForm()
										values = {
											...values,
											...weiJueForm,
										}
									}

									if (values.ruleTaskType.includes(this.FU_KAN)) {
										const fuKanForm = await (this.$refs
											.fuKanRules as any).getForm()
										values = {
											...values,
											...fuKanForm,
										}
									}

									delete values.ruleTaskType
									resolve(values)
								} else {
									reject(err)
								}
							}
						)
					} else if (values1.ruleBaseType === this.RULE_GENERAL) {
						const generalValues = await (this.$refs
							.generalConfigure as any).getForm()
						const values = Object.assign(values1, generalValues)
						resolve(values)
					}
				} else {
					reject(errors)
				}
			})
		})
	}

	private created() {
		this.ruleForm = this.$form.createForm(this)
		this.ruleContentForm = this.$form.createForm(this)
		this.pendingMulti = new MultipleInput(1, MAX_PENDING)
		this.resurveyMulti = new MultipleInput(1, MAX_RESURVEY)
	}
}
